import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Loaded on demand so Ory Elements and the lab stay out of the main bundle
// for everyone who never opens this staging diagnostic.
export const Route = createFileRoute("/_authenticated/session-inspector")({
  component: lazyRouteComponent(
    () => import("@/app/session-inspector/session-inspector-page"),
    "SessionInspectorPage"
  ),
});
